var _defs, _rect, _rect2, _g, _rect3, _rect4, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTorsecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 400,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "neonGlowScreen",
    x: "-60%",
    y: "-60%",
    width: "220%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4,
    result: "blur1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "screenMetal",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#132227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#070B0D"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    rx: 16,
    fill: "#101418"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.5,
    width: 89,
    height: 89,
    rx: 13,
    fill: "url(#screenMetal)",
    stroke: "#4DD0E1",
    strokeWidth: 2.2,
    filter: "url(#neonGlowScreen)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#4DD0E1",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    fill: "none",
    filter: "url(#neonGlowScreen)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 72,
    x2: 50,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 86,
    x2: 62,
    y2: 86
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22,
    width: 56,
    height: 50,
    rx: 4,
    fill: "url(#screenMetal)",
    stroke: "#4DD0E1",
    strokeWidth: 2.6,
    filter: "url(#neonGlowScreen)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 44,
    height: 38,
    rx: 2,
    fill: "none",
    stroke: "#4DD0E1",
    strokeWidth: 1,
    opacity: 0.6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#4DD0E1",
    filter: "url(#neonGlowScreen)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 10,
    height: 10,
    fill: "none",
    stroke: "#4DD0E1",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 35,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 32,
    width: 10,
    height: 10,
    fill: "none",
    stroke: "#4DD0E1",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 35,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 52,
    width: 10,
    height: 10,
    fill: "none",
    stroke: "#4DD0E1",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 55,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 33,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 33,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 39,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 45,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 51,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 46,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 46,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 52,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 58,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 58,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 60,
    width: 3,
    height: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorsecure);
export default __webpack_public_path__ + "static/media/torsecure.61e1ac43fa3145e269030e8589131913.svg";
export { ForwardRef as ReactComponent };